var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "carousel_clients wow fadeInUp",
      attrs: { "data-wow-delay": "0.7s" },
    },
    _vm._l(_vm.items, function (item, i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "slide position-relative",
          class: [!item.url ? "unlinked" : ""],
          attrs: { src: item.img },
        },
        [
          _c("img", { attrs: { src: item.img } }),
          _vm._v(" "),
          item.url
            ? _c("a", {
                staticClass: "position-absolute l-0 t-0 w-100 h-100 zi-1",
                attrs: { href: item.url, target: "_blank" },
              })
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }